
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

export default {
    setup() {
        const { t, locale } = useI18n({ useScope: "global" });
        const url = ref(t("general.rgpdUrl"));

        watch(locale, () => {
            url.value = t("general.rgpdUrl");
        });

        return {
            url
        };
    }
};
